import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';

const customApp: App = {
  appId: 'custom',
};class LoadGoogleTagManager {
  gtmId = '';

  gtmEnvironment = '';

  constructor({ config }) {
    this.gtmId = config.GOOGLE_TAG_MANAGER_ID;
    this.gtmEnvironment = config.GOOGLE_TAG_MANAGER_ENVIRONMENT || '';
  }

  loadScript() {
    if (!this.gtmId || document.getElementById('indigo-google-tag-manager')) {
      return;
    }

    const environment = this.gtmEnvironment
      && !this.gtmEnvironment.startsWith('&')
      ? `&${this.gtmEnvironment}`
      : this.gtmEnvironment;

    const dataLayer = Reflect.get(window, 'dataLayer') || [];
    Reflect.set(window, 'dataLayer', dataLayer);

    const gtag = Reflect.get(window, 'gtag') || function gtag() {
      dataLayer.push(arguments);
    };
    Reflect.set(window, 'gtag', gtag);
    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      functionality_storage: 'granted',
      personalization_storage: 'denied',
      security_storage: 'granted',
    });

    dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = 'indigo-google-tag-manager';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}${environment}`;
    document.head.appendChild(script);
  }
}
addScript(customApp, LoadGoogleTagManager);

export default customApp;